import { motion } from "framer-motion";
import { CONTENT } from "../data/content";
import { scrollToSection } from "../lib/smooth";

const LINKS = [
    { label: "Work", target: "#work", testid: "nav-work-link" },
    { label: "Resume", target: "#resume", testid: "nav-resume-link" },
    { label: "Docs", target: "#docs", testid: "nav-docs-link" },
    { label: "About", target: "#about", testid: "nav-about-link" },
    { label: "Contact", target: "#contact", testid: "nav-contact-link" },
];

const LogoMark = () => (
    <svg viewBox="0 0 64 64" className="h-8 w-8" aria-hidden="true">
        <g fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="square">
            <path d="M14 22 V14 H22" />
            <path d="M42 14 H50 V22" />
            <path d="M50 42 V50 H42" />
            <path d="M22 50 H14 V42" />
        </g>
        <circle cx="32" cy="32" r="7" fill="#E50914" />
    </svg>
);

export const Nav = () => (
    <motion.header
        initial={{ y: -80, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1, delay: 1.6, ease: [0.16, 1, 0.3, 1] }}
        className="fixed inset-x-0 top-0 z-50 mix-blend-difference"
        data-testid="site-nav"
    >
        <div className="flex items-center justify-between px-6 py-5 md:px-12">
            <button
                data-testid="nav-logo"
                onClick={() => scrollToSection("#top")}
                className="flex items-center gap-3 text-white transition-opacity duration-300 hover:opacity-70"
                aria-label="Back to top"
            >
                <LogoMark />
                <span className="font-display text-xl tracking-[0.2em]">{CONTENT.name}</span>
            </button>
            <nav className="hidden items-center gap-6 lg:flex">
                {LINKS.map((link) => (
                    <button
                        key={link.target}
                        data-testid={link.testid}
                        onClick={() => scrollToSection(link.target)}
                        className="link-line font-body text-xs uppercase tracking-[0.25em] text-white"
                    >
                        {link.label}
                    </button>
                ))}
            </nav>
            <button
                data-testid="nav-contact-mobile"
                onClick={() => scrollToSection("#contact")}
                className="link-line font-body text-xs uppercase tracking-[0.3em] text-white lg:hidden"
            >
                Contact
            </button>
        </div>
    </motion.header>
);
